import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants'
import {NatPostResidentLogin} from './NatPostResidentLogin';
import {NatPostResidentLogout} from './NatPostResidentLogout';

export interface PostLoginParams {
    username: string
    password: string
}

export default class NatLoginRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // ログイン認証
    async postLogin(requestParams: PostLoginParams): Promise<NatPostResidentLogin> {
        return await this.http.post(`/resident/login`, {
                username: encodeURIComponent(requestParams.username),
                password: encodeURIComponent(requestParams.password),
            }, ContentType.FORM,
        )
    }

    // ログアウト（居住者）
    async postLogout(): Promise<NatPostResidentLogout> {
        return await this.http.post(`/resident/logout`, {}, ContentType.JSON,
        )
    }

}
